import { DecreaseParticipant } from '../utils/automateDecreaseOperation';

/**
 * Lista de participantes para la Reducción de Capital (Capital Decrease).
 * Rellena con los datos de cada participante antes de ejecutar el script.
 *
 * Datos por participante:
 * - partnerSearchTerm: término de búsqueda del socio (mín. 3 caracteres).
 *   Ej: "Juan Pérez", "García López", parte del nombre que identifique al socio.
 * - sharesToDecrease: (opcional) nº de participaciones a reducir. Solo para registro.
 *   El script hace clic en el único rango de "Rangos disponibles"; la cantidad
 *   real viene del rango. Útil para documentar o validar.
 *
 * La clase se selecciona una sola vez al inicio (defaultClassSearchTerm en config).
 * El rango se obtiene haciendo clic en el único rango de "Rangos disponibles"
 * (cada socio debe tener exactamente 1 rango).
 */

/** Config por defecto para el botón de automatización. Ajustar defaultClassSearchTerm según la sociedad. */
export const decreaseAutomationConfig = {
  defaultClassSearchTerm: 'Clase B',
};

export const axaDecreaseParticipantsList: DecreaseParticipant[] = [
  // Ejemplo:
  // { partnerSearchTerm: 'Nombre del Socio', sharesToDecrease: 100 },
  // { partnerSearchTerm: 'Otro Socio', sharesToDecrease: 50 },
];
